import styled from 'styled-components';

export const TokenPageContainer = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  padding: 0px 48px;
  padding-bottom: 48px;
  width: 100%;

  .heading-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

export const TokenTiersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  width: 100%;
`;

export const PaymentForm = styled.div`
  max-width: 500px;
  margin: 30px auto;
  padding: 30px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background: white;
  
  h3 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .order-summary {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    
    .summary-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      
      &.bonus {
        color: #28a745;
        font-weight: bold;
      }
    }
    
    .summary-total {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      font-size: 1.1rem;
      border-top: 1px solid #dee2e6;
      padding-top: 10px;
      margin-top: 10px;
    }
  }
`;

export const BalanceContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 16px;

  h1 {
    font-family: 'Roboto Condensed';
    font-size: 48px;
    line-height: 48px;
    opacity: 0.5;
  }
`;

export const TokenBalanceDisplay = styled.div`
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 100px;
  display: flex;
  gap: 8px;
  padding: 8px 8px;
  padding-right: 16px;
  

  img {
    height: 32px;
    width: 32px;
  }

  span {
    color: #FFFFFF;
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: 600;
  }
`;

export const PromoCodeInput = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 640px;
`;

export const PromoCodeRow = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  margin-left: 10px;
  
  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const SuccessMessage = styled.div`
  background: #d4edda;
  box-sizing: border-box;
  font-family: 'Roboto Condensed', sans-serif;
  color: #155724;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #c3e6cb;
  text-align: center;
  max-width: 948px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  background: #f8d7da;
  box-sizing: border-box;
  color: #721c24;
  font-family: 'Roboto Condensed', sans-serif;
  padding: 12px;
  border-radius: 6px;
  text-align: center;
  border: 1px solid #f5c6cb;
  max-width: 948px;
  width: 100%;
`;

export const TokenActivityContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  width: 100%;
  
  h1 {
    font-family: 'Roboto Condensed';
    font-size: 48px;
    line-height: 48px;
    opacity: 0.5;
    text-align: center;
    width: 100%;
  }
`;